// extracted by mini-css-extract-plugin
export default {"cards":"style_cards__5ag+5","card":"style_card__Fsy39","title":"style_title__3e2fL","root":"style_root__ogTY8"};